/* eslint-disable react/prop-types */ // TODO: add props
import Immutable from 'immutable';
import PT from 'prop-types';
import IPT from 'react-immutable-proptypes';
import cx from 'classnames';
import styles from './style.scss';
import { Tick, Cross } from '../CheckMarks';
import ChecklistDescription from './ChecklistDescription';

const ExemplarResponseChecklistItem = ({
  description,
  value,
  onChange,
  onMouseEnter,
  onMouseLeave,
  isHyperlinked,
  isHighlighted,
  serial,
  isSubmitted,
}) => (
  <div
    className={cx({
      [styles.checklistItem]: true,
      [styles.highlighted]: isHighlighted,
    })}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    data-testid="checklist-item"
  >
    <div className={styles.options} data-test={`checklist-item-${serial}`}>
      {!isSubmitted || value === true ? (
        <Tick
          onClick={() => onChange(true)}
          selected={value === true}
          disabled={isSubmitted}
        />
      ) : null}

      {!isSubmitted || value === false ? (
        <Cross
          onClick={() => onChange(false)}
          selected={value === false}
          disabled={isSubmitted}
        />
      ) : null}
    </div>
    <div className={styles.description}>
      <ChecklistDescription>{description}</ChecklistDescription>
      {isHyperlinked ? (
        <sup className={styles.hyperlinkedItemSupertext} data-serial={serial}>
          {serial}
        </sup>
      ) : null}
    </div>
  </div>
);

const Checklist = ({
  items,
  reflectionMap,
  onChange,
  highlightedSerial,
  onHighlightSerial,
  isSubmitted,
}) => (
  <div data-testid="checklist" className={styles.checklistContainer}>
    {items.map((item) => (
      <ExemplarResponseChecklistItem
        key={item.get('serial')}
        value={reflectionMap.get(`${item.get('id')}`)}
        description={item.get('description')}
        isHyperlinked={item.get('is_hyperlinked')}
        serial={item.get('serial')}
        onChange={(value) =>
          onChange(
            item.get('id'),
            value,
            reflectionMap.get(`${item.get('id')}`)
          )
        }
        onMouseEnter={() => onHighlightSerial(Number(item.get('serial')), true)}
        onMouseLeave={() =>
          onHighlightSerial(Number(item.get('serial')), false)
        }
        isSubmitted={isSubmitted}
        isHighlighted={highlightedSerial === Number(item.get('serial'))}
      />
    ))}
  </div>
);

Checklist.propTypes = {
  items: IPT.listOf(
    IPT.contains({
      description: PT.string.required,
      is_hyperlinked: PT.bool,
      serial: PT.number,
      id: PT.number,
    })
  ),
  // reflectionMap are an object where the key is the serial and the value is true, false or null.
  reflectionMap: IPT.mapOf(PT.bool, PT.string),
  onChange: PT.func,
  highlightedSerial: PT.number,
  onHighlightSerial: PT.func,
  isSubmitted: PT.bool,
};

Checklist.defaultProps = {
  onChange: () => null,
  reflectionMap: Immutable.Map(),
  items: Immutable.List(),
};

export default Checklist;
